import { Container } from "./styled";

const ErrorInput = (props) => {
    return (
        <Container>
            {props.children}
        </Container>
    )
}

export default ErrorInput
